import './MainPageSub05_1.scss';
import fig_abcd from '../images/home/fig_abef.png'; 
import MainPageSub05_2 from './MainPageSub05_2';
import React from "react";

const MainPageSub05_1 = () => {
    return (
        <div className="MainPageSub05_1">
 

                <table className='table-main' border="1">
                    <tr>
                        <td className='td-highlight1'>
                            <span>의학계열</span>
                            <span>과학계열</span>
                            <span>공학계열</span>
                            <span>연구계열</span>
                            <span>법률계열</span>
                            <span>금융계열</span>
                        </td>

                        <td>
                            <span>건축/디자인계열</span>
                            <span>개발계열</span>
                            <span>광고/정보계열</span>
                            <span>교육계열</span>
                            <span>서비스계열</span>
                        </td>

                        <td>
                            <span>경영계열</span>
                            <span>기획/컨설팅계열</span>
                            <span>광고/정보계열</span>
                            <span>교육계열</span>
                            <span>서비스계열</span>
                        </td>


                        <td className='td-highlight1'>
                            <span>건축/디자인계열</span>
                            <span>개발계열</span>
                            <span>기계/전자계열</span>
                            <span>정보/컴퓨터계열</span>
                        </td>

                    </tr>

                    <tr>
                        <td rowSpan={2}>
                            <span>건축/디자인계열</span>
                            <span>개발계열</span>
                            <span>과학계열</span>
                            <span>공학계열</span>
                            <span>기계/전자계열</span>
                            <span>정보/컴퓨터계열</span>
                            <span>경영계열</span>
                            <span>기획/컨설팅계열</span>
                        </td>

                        <td className='td-highlight2'>
                            <span>경영계열</span>
                            <span>기획/컨설팅계열</span>
                            <span>정치계열</span>
                            <span>개발계열</span>
                        </td>

                        <td className='td-highlight2'>
                            <span>언어계열</span>
                            <span>외교계열</span>
                            <span>방송계열</span>
                            <span>스포츠계열</span>
                            <span>서비스계열</span>
                        </td>

                        <td rowSpan={2}>
                            <span>디자인계열</span>
                            <span>교육계열</span>
                            <span>환경/문화계열</span>
                            <span>보건계열</span>
                            <span>디자인계열</span>
                            <span>방송계열</span>
                            <span>환경/문화계열</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='td-highlight2'>
                            <span>의학계열</span>
                            <span>과학계열</span>
                            <span>공학계열</span>
                            <span>연구계열</span>
                            <span>법률계열</span>      
                        </td>

                        <td className='td-highlight2'>
                            <span>예술계열</span>
                            <span>문학계열</span>
                            <span>교육계열</span>
                            <span>봉사계열</span>
                        </td>
                    </tr>

                    <tr>
                        <td className='td-highlight1'>
                            <span>교육계열</span>
                            <span>경영계열</span>
                            <span>기획/컨설팅계열</span>
                        </td>

                        <td>
                            <span>물리／화학계열</span>
                            <span>생명과／공학계열</span>
                            <span>사회과학계열</span>
                            <span>정보/컴퓨터계열</span>
                            <span>상경/금융계열</span>
                        </td>

                        <td>
                            <span>보건계열</span>
                            <span>행정계열</span>
                            <span>인문과학계열</span>
                            <span>생명과 / 공학계열</span>
                            <span>사회과학계열</span>
                        </td>

                        <td className='td-highlight1'>
                            <span>사회과학계열</span>
                            <span>정보/컴퓨터계열</span>
                            <span>상경계열</span>
                            <span>법률계열</span>
                        </td>

                    </tr>
                </table>


        </div>
    );
};

export default MainPageSub05_1;
